import client from "./client";

export const fetchKpiMonthly = async (params = {}) => (await client.get("/kpi/monthly", { params })).data;
export const fetchMyKpi = async (month) => (await client.get("/kpi/mine", { params: { month } })).data;
export const fetchKpiWeights = async () => (await client.get("/kpi/weights")).data;
export const saveKpiWeights = async (body) => (await client.put("/kpi/weights", body)).data;
